import { gql } from '@apollo/client'

export const GET_APP_VERSIONS = gql`
  query GetAppVersions {
    appVersions {
      id
      appIdentifier
      version
      minimumVersion
      forceUpdate
      updateMessage
      platform
      createdAt
      createdBy
    }
  }
`

export const GET_APP_VERSION_BY_ID = gql`
  query GetAppVersionById($id: Long!) {
    appVersionById(id: $id) {
      id
      appIdentifier
      version
      minimumVersion
      forceUpdate
      updateMessage
      platform
    }
  }
`

export const GET_APP_VERSIONS_BY_PLATFORM = gql`
  query GetAppVersionsByPlatform($platform: String!) {
    appVersionsByPlatform(platform: $platform) {
      id
      appIdentifier
      version
      minimumVersion
      forceUpdate
      updateMessage
      platform
    }
  }
`
